/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import {config} from '../../constants/Constants'
import Header from "../../views/Common/Header/Header";
import Footer from "../../views/Common/Footer/Footer";
import Alert from "../../shared/Alerts"
import Spinner from "../../shared/Spinner"
import Tabletop from "tabletop";
import axios from 'axios';
import Papa from 'papaparse'

export default class View extends React.Component{   
    constructor(){        
        super();
        this.handleChange.bind(this)
        this.state = {             
            literals : {},
            displayLang : '',
            literalsData : [],
            formData : {fname:'',lname:''},
            success : false,
            msg : '',
            spinner : false,
            params : {}
            }
        }          
    
        componentDidMount() { 
            const params = new URLSearchParams(window.location.search)
            console.log(params.get('lot-name'),params.get('lot-type'),params.get('type'))
            let obj =  {
                type : params.get('lot-type'),
                name : params.get('lot-name'),
                rate : params.get('rate'),
            }           
            let subject= {
                subject : params.get('lot-name')
            }
            this.setState({formData : subject, params : obj})
            let literal = JSON.parse(localStorage.getItem("literals"));                
            let selectLang = localStorage.getItem("displayLang") 
            if(literal !== null){
                this.setState({literals : literal});           
                this.setState({displayLang : selectLang});   
            }
            if(selectLang == null){ 
                selectLang = navigator.language || navigator.userLanguage; 
                selectLang = selectLang.split('-')[0] 
                console.log(selectLang)
                this.setState({displayLang : selectLang});              
            }
            // axios.get(config.url.spreadSheet + "Literals").then((res)=>{
            //     let result = this.mapLanguages(selectLang, res.data);            
            //     this.setState({
            //         literals : result,
            //         literalsData : res.data
            //     }) 
            // })
            Papa.parse(config.url.spreadSheet + "pub?gid=1443882505&output=csv", {
                download: true,
                header: true,
                complete: (res) => {
                    let result = this.mapLanguages(selectLang, res.data);            
                    this.setState({
                        literals : result,
                        literalsData : res.data
                    })
                },
            });
        }
        mapLanguages(language, languageData){           
            let languageArray = {};
            if(language == 'fr'){            
                this.setState({displayLang : 'fr'});
                localStorage.setItem("displayLang", 'fr')
            }else if(language == 'en'){            
                this.setState({displayLang : 'en'});
                localStorage.setItem("displayLang", 'en')
            } 
            languageData.forEach((item)=>{                          
                languageArray[item.key] = item[language];            
            })
            localStorage.setItem('literals', JSON.stringify(languageArray))
            return languageArray;
        }
    
        selectedLanguage(e){         
            this.setState({displayLang : e});
            let result = this.mapLanguages(e,this.state.literalsData);
            this.setState({literals : result});
            window.location.reload();
        }

    handleSubmit(e){
        e.preventDefault();
        let form = this.state.formData;
        form['emailBody'] = this.state.literals.emailBody        
        form['kindRegards'] = this.state.literals.kindRegards        
        this.setState({spinner : true});
        axios.post(config.url.API_URL+'sendEmail', form)
            .then(result => {
                this.setState({
                    success : true,
                    msg : this.state.literals.emailBody,
                    formData : {},
                    spinner : false
                })
            })
    }

    handleChange(event) {        
        let form = this.state.formData;
        form[event.target.name] = event.target.value;       
        this.setState({
            formData : form
        }, console.log(this.state.formData));       
    }

    render() {
              

    return(
            <>  
                <Header
                    displayLang = {this.state.displayLang}                    
                    literals = {this.state.literals}
                    
                    selectedLanguage = {(e) => {this.selectedLanguage(e)}}
                />
                <div className="inner-header back-img">                          
                </div>
                <div className="container contact-us">
                    <div className="row m-0 justify-content-center align-items-center" style={{width:'100%'}}>
                        <div className="col-md-6">
                            <div className="contact-body text-center">
                                <h2>{this.state.literals.haveQuestion}</h2>
                                <p>{this.state.literals.hereToHelp}</p>
                                <a href="#" className="btn btn-lg rounded-pill btn-green">{this.state.literals.askQuestion}</a>
                            </div>
                            <div className="card-deck" style={{marginTop: '20px'}}>
                                <div className="card shadow">
                                    <div className="card-body">
                                        <h4 className="text-green">
                                            {this.state.params.name}
                                        </h4>
                                        <h5 className="text-blue">
                                            {this.state.params.type}
                                        </h5>
                                    </div>
                                    <div class="card-footer">
                                        <span>{this.state.params.rate}</span>
                                    </div>
                                </div>                                   
                            </div>
                            <div className="contact-form">
                                <h3 className="text-center">{this.state.literals.contact}</h3>
                                <div className="mt-2">
                                    <Alert
                                        success = {this.state.success}
                                        msg = {this.state.msg}
                                    />
                                </div>  
                                <form onSubmit={(e)=>{this.handleSubmit(e)}}>
                                    <div className="form-group">
                                        <label for="exampleInputEmail1">{this.state.literals.fname}</label>
                                        <input type="text" className="form-control" name="fname" id="exampleInputEmail1"
                                            value = {this.state.formData.fname}
                                            onChange={(e)=>{this.handleChange(e)}}
                                            aria-describedby="emailHelp" placeholder={this.state.literals.fname}
                                            required/>
                                    </div>
                                    <div className="form-group">
                                        <label for="exampleInputEmail1">{this.state.literals.lname}</label>
                                        <input type="text" className="form-control" 
                                            name="lname"
                                            value = {this.state.formData.lname}
                                            onChange={(e)=>{this.handleChange(e)}}
                                            id="exampleInputEmail1" aria-describedby="emailHelp" 
                                            placeholder={this.state.literals.lname}
                                            required/>
                                    </div>
                                    <div className="form-group">
                                        <label for="exampleInputEmail1">{this.state.literals.email}</label>
                                        <input type="email" className="form-control" id="exampleInputEmail1" 
                                            name="email"
                                            value = {this.state.formData.email}
                                            onChange={(e)=>{this.handleChange(e)}}
                                            aria-describedby="emailHelp" placeholder={this.state.literals.email}
                                            required/>
                                    </div>
                                    <div className="form-group">
                                        <label for="exampleInputEmail1">{this.state.literals.phNo}</label>
                                        <input type="number" className="form-control" 
                                            name="ph_no"
                                            value = {this.state.formData.ph_no}
                                            onChange={(e)=>{this.handleChange(e)}}
                                            id="exampleInputEmail1" aria-describedby="emailHelp" placeholder={this.state.literals.phNo}
                                            required/>
                                    </div>
                                    {/* <div className="form-group">
                                        <label for="exampleInputEmail1">Ville</label>
                                        <input type="text" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Ville"/>
                                    </div>
                                    <div className="form-group">
                                        <label for="exampleInputEmail1">Enquête</label>
                                        <select class="form-control" id="exampleFormControlSelect1">
                                            <option>Votre question ou préoccupation</option>
                                            <option>Service de stationnement événementiel</option>
                                            <option>Abonnement mensuel</option>
                                            <option>Problème général</option>
                                            <option>Demande de services de gestion</option>
                                            <option>Problème avec notre prestation de service</option>
                                            <option>Problème relié avec le  site Web</option>
                                        </select>
                                    </div> */}
                                    <div className="form-group">
                                        <label for="exampleFormControlTextarea1">{this.state.literals.yourQuestion}</label>
                                        <textarea className="form-control" 
                                            name="yourQuestion"
                                            value = {this.state.formData.question}
                                            onChange={(e)=>{this.handleChange(e)}}
                                            id="exampleFormControlTextarea1" rows="3" required></textarea>
                                    </div>
                                    <button type="submit" className="btn btn-lg w-100 rounded-pill btn-primary">{this.state.literals.sendMsg}</button>
                                    </form>
                            </div>   
                        </div>
                    </div>
                </div>
                <Spinner
                    spinner = {this.state.spinner}
                />
                <Footer
                    literals = {this.state.literals}
                />  
            </>
        )
    }
}